import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from './Delete_check_lottie.json';

const Delete_check_lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='main'>
                <div className='Green_Check_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    // height={60}
                    // width={60}          
                    />
                </div>
            </section>
        </>
    )
}

export default Delete_check_lottie
